import { Component } from '@angular/core';

@Component({
  selector: 'pc-ornate-frame',
  standalone: true,
  imports: [],
  templateUrl: './ornate-frame.component.html',
  styleUrl: './ornate-frame.component.scss'
})
export class OrnateFrameComponent {

}
